import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getPosition, mapPosition } from '../funcs/funcs';

@Pipe({
  name: 'bodyPosition',
  pure: true
})
export class BodyPositionPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(pos: number): string {
    // mapPosition: maps the numeric code → intermediate
    // getPosition: final human-readable string (with translations)
    return getPosition(mapPosition(pos), this.translate);
  }
}